module.exports = __webpack_public_path__ + "img/sacDesktop-pt-BR.7ae0e102.png";